import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {TextPlugin} from 'gsap/TextPlugin'
import {SplitText} from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)
// gsap.registerPlugin(TextPlugin) 

export default class Animations {
  static init() {
    console.debug('== Animations components ==')

    // General animations
    console.debug('  -> Animate general components')

    const animateRight = document.querySelectorAll('.animate-right')
    if (animateRight.length != 0) {
      animateHorizontal(animateRight, 20)
    }

    const animateLeft = document.querySelectorAll('.animate-left')
    if (animateLeft.length != 0) {
      animateHorizontal(animateLeft, -20)
    }

    const animateBottom = document.querySelectorAll('.animate-bottom')
    if (animateBottom.length != 0) {
      animateVertical(animateBottom, 20)
    }

    const animateTop = document.querySelectorAll('.animate-top')
    if (animateTop.length != 0) {
      animateVertical(animateTop, -20)
    }

    const animateFadeItems = document.querySelectorAll('.animate-fade')
    if (animateFadeItems.length != 0) {
      animateFade(animateFadeItems)
    }

    const animateTitleItems = document.querySelectorAll('.animate-title')
    if (animateTitleItems.length != 0) {
      animateTitle(animateTitleItems)
    }

    const animateBottomStagger = document.querySelectorAll('.animate-bottom-stagger')
    if (animateBottomStagger.length != 0) {
      animateInStaggerBottom(animateBottomStagger, 20, 0.15)
    }

    const animatePopoutStaggerItems = document.querySelectorAll('.animate-popout-stagger')
    if (animatePopoutStaggerItems.length != 0) {
      animatePopoutStagger(animatePopoutStaggerItems)
    }

    const animateTextRowsItems = document.querySelectorAll('.animate-text-rows')
    if (animateTextRowsItems.length != 0) {
      animateTextRows(animateTextRowsItems)
    }

    const animateTextLettersItems = document.querySelectorAll('.animate-text-letters')
    if (animateTextLettersItems.length != 0) {
      animateTextLetters(animateTextLettersItems)
    }

    // Parallax images
    const parallaxImages = document.querySelectorAll('.parallax-image')
    if (parallaxImages.length != 0) {
      animateParallaxImages(parallaxImages)
    }
  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

function animateHorizontal(items, offset) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({ autoRemoveChildren: true, paused: true })

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      x: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

function animateVertical(items, offset, start = 'top 95%') {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      y: offset,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: start,
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

function animateFade(items) {
  items.forEach((item) => {
    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    tlItem.from(item, {
      [property]: 0,
      duration: 2,
      delay: 0.5,
      ease: 'expo.out',
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 95%',
      end: 'bottom',
      animation: tlItem,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

function animateTitle(items) {
  
  items.forEach((item) => {
    if (!item.textContent || item.textContent.trim() === '') {
      console.warn('animate-title element without text, skipping SplitText')
      return
    }

    let splitElem
    try {
      splitElem = new SplitText(item, {
        type: 'words,chars',
      })
    } catch (error) {
      console.error('Error creating SplitText (animate-title):', error)
      return
    }

    if (!splitElem.chars || splitElem.chars.length === 0) {
      console.warn('No chars created by SplitText (animate-title)')
      return
    }

    const isFirstView = item.classList.contains('first-view')
    const property = isFirstView ? 'autoAlpha' : 'opacity'

    if (isFirstView) {
      gsap.set(item, { autoAlpha: 1 })
      gsap.set(splitElem.chars, { autoAlpha: 0, y: 130 })

      gsap.to(splitElem.chars, {
        autoAlpha: 1,
        duration: 0.5,
        ease: 'expo.out',
        y: 0,
        stagger: 0.1,
      })

      return
    }

    let tl = gsap.timeline({paused: true})

    tl.from(splitElem.chars, {
      [property]: 0,
      duration: 0.5,
      ease: 'expo.out',
      y: 130,
      stagger: 0.1,
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 85%',
      end: 'bottom 90%',
      animation: tl,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

const animateInStaggerBottom = (items) => {
  items.forEach((item) => {
    gsap.set(item, { autoAlpha: 1, y: 0 })

    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})
    let stItem = null

    // Select subitems within the main item
    const subitems = Array.from(
      item.querySelectorAll('.animate-stagger-item')
    )
    
    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity';

    if( subitems.length > 0 ){
      tlItem.from(subitems, {
        [property]: 0,
        duration: 0.75,
        y: 100,
        ease: 'Power2.easeOut',
        stagger: 0.2,
        onComplete: () => {
          stItem.kill()
          item.classList.remove('.animate-in-stagger-item')
        },
      })
  
      stItem = ScrollTrigger.create({
        trigger: item,
        start: 'top 90%',
        animation: tlItem,
        // markers: true,
        toggleActions: 'play none none none',
      })
    }
  })
}

function animateTextRows(items) {
  items.forEach((item) => {
    if (!item.textContent || item.textContent.trim() === '') {
      console.warn('animate-text-rows element without text, skipping SplitText')
      return
    }

    let splitElem
    try {
      splitElem = new SplitText(item, {
        type: 'lines',
        linesClass: 'line-split-text-target',
      })
    } catch (error) {
      console.error('Error creating SplitText (animate-text-rows):', error)
      return
    }

    if (!splitElem.lines || splitElem.lines.length === 0) {
      console.warn('No lines created by SplitText (animate-text-rows)')
      return
    }

    const isFirstView = item.classList.contains('first-view')
    const property = isFirstView ? 'autoAlpha' : 'opacity'

    if (isFirstView) {
      gsap.set(item, { autoAlpha: 1 })
      gsap.set(splitElem.lines, { autoAlpha: 0, y: 130 })

      gsap.to(splitElem.lines, {
        autoAlpha: 1,
        duration: 1.2,
        ease: 'expo.out',
        y: 0,
        stagger: 0.2,
      })

      return
    }

    let tl = gsap.timeline({paused: true})

    tl.from(splitElem.lines, {
      [property]: 0,
      duration: 1.2,
      ease: 'expo.out',
      y: 130,
      stagger: 0.2,
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 85%',
      end: 'bottom 90%',
      animation: tl,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

function animateTextLetters(items) {
  items.forEach((item) => {
    if (!item.textContent || item.textContent.trim() === '') {
      console.warn('animate-text-letters element without text, skipping SplitText')
      return
    }

    let splitElem
    try {
      splitElem = new SplitText(item, {
        type: 'words,chars',
      })
    } catch (error) {
      console.error('Error creating SplitText (animate-text-letters):', error)
      return
    }

    if (!splitElem.chars || splitElem.chars.length === 0) {
      console.warn('No chars created by SplitText (animate-text-letters)')
      return
    }

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    let tl = gsap.timeline({paused: true})

    tl.from(splitElem.chars, {
      [property]: 0,
      duration: 0.5,
      ease: 'power2.out',
      y: 20,
      rotation: 10,
      stagger: 0.02,
    })

    ScrollTrigger.create({
      trigger: item,
      start: 'top 85%',
      end: 'bottom 90%',
      animation: tl,
      markers: false,
      toggleActions: 'play none none none',
    })
  })
}

function animatePopoutStagger(items) {
  items.forEach((item) => {
    gsap.set(item, { autoAlpha: 1 })

    let tlItem = gsap.timeline({autoRemoveChildren: true, paused: true})
    let stItem = null

    // Select subitems within the main item
    const subitems = Array.from(
      item.querySelectorAll('.animate-stagger-item')
    )

    const property = item.classList.contains('first-view') ? 'autoAlpha' : 'opacity'

    if( subitems.length > 0 ){
      tlItem.from(subitems, {
        [property]: 0,
        scale: 0.5,
        duration: 0.75,
        ease: 'Power2.easeOut',
        stagger: 0.2,
        onComplete: () => {
          stItem.kill()
          item.classList.remove('.animate-popout-stagger')
        },
      })

      stItem = ScrollTrigger.create({
        trigger: item,
        start: 'top 90%',
        animation: tlItem,
        // markers: true,
        toggleActions: 'play none none none',
      })
    }
  })
}

function animateParallaxImages(items) {
  items.forEach((item) => {
    gsap.to(item, {
      y: '15%',
      ease: 'none',
      scrollTrigger: {
        trigger: item.closest('section'),
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
        markers: false,
      },
    })
  })
}